import { Button, Modal } from "../../";

/**
 * Simple confirmation modal for default child linking
 */
export default function DefaultLinkModal({
  open,
  onClose,
  onConfirm,
  loading = false
}) {
  return (

    <Modal
        loading={loading}
        open={open}
        onClose={onClose}
        onConfirm={onConfirm}
        backdrop="static"
        keyboard={true}
        title="Default Link"
        text="Are you sure you want to use the default child link?"
        confirmColor="blue"
        cancelColor="red"
        />
  );
}